import React from "react";
import * as S from "./styles";
import { moneyMask } from "~/utils/mask";

const InstallmentBox = ({ lastParcel }) => {
    return (
        <S.InstallmentBox>
            <S.BoxTitle>Parcelamento</S.BoxTitle>

            <S.ParcelText>
                O parcelamento da fatura é opcional e pode ser contratado caso você precise.
            </S.ParcelText>

            <S.OptionCardTop>
                <S.OptionLabel>Entrada</S.OptionLabel>
                <S.OptionValueTop>
                    1x {moneyMask(lastParcel?.entrada)}
                </S.OptionValueTop>
            </S.OptionCardTop>

            <S.OptionCard>
                <S.OptionLabel>Parcelas</S.OptionLabel>
                <S.OptionValue>
                    {lastParcel?.quantidade - 1 || 0}x {moneyMask(lastParcel?.valor)}
                </S.OptionValue>
            </S.OptionCard>
        </S.InstallmentBox>
    );
};

export default InstallmentBox;